import { useAppState } from 'Context/AppContext/AppContext'

const useConfigureActivePlans = () => {
  const {
    nonprofitOrgConfig: { loading: nonprofitLoading },
    funderOrgConfig: { loading: funderLoading, orgName: funderOrgName },
    awsFeatureFlags: { loading: featureFlagsLoading },
    userConfig: { loading: userLoading },
  } = useAppState()

  const isFunderUser = !!funderOrgName

  const configIsLoading =
    nonprofitLoading || funderLoading || featureFlagsLoading || userLoading

  return {
    configIsLoading,
    isFunderUser,
  }
}

export default useConfigureActivePlans
